export const mapTableRows = (data, columns) => {
  if (!Array.isArray(data)) return [];
  return data.map((row) => ({
    ...row,
    ...columns.reduce((acc, col) => {
      if (col.key) {
        // acc[col.key] = row[col.key] || "-"; // mahee change this one 111025
           acc[col.key] = (row[col.key] === null || row[col.key] === undefined || row[col.key] === "") ? "-" : row[col.key];
      }
      return acc;
    }, {}),
  }));
};
